import type { Error } from '../types';
import { NUMBERS_OR_SPACE } from '../utils/regex';

export const numbersOrSpace =
  (message?: Error['message'], allowEmpty = false) =>
  (value: string): Error => {
    const valid = !!value && NUMBERS_OR_SPACE.test(value);
    return {
      valid: allowEmpty ? !value || valid : valid,
      message
    };
  };
